/**
 * Press that names Omens (PRD 11.3, /imprensa): every article already linked from the site, each one opened on
 * 24/10/2026 (it answers, names Omens in its text; headline and date as published). Not the complete list: Omens
 * still has to send it (PRD 14). Newest first.
 */

export interface PressItem {
  outlet: string
  title: string
  href: string
  /** Publication date, ISO. */
  date: string
}

/** A logo of the press block: the outlet's official logo, in the two colors of the site (`mint` on dark, `dark` on light). */
export interface PressLogo {
  src: { mint: string; dark: string }
  width: number
  height: number
}

export const OMENS_PRESS: PressItem[] = [
  {
    outlet: 'Startups',
    title: 'Omens expande e lança Isha, sua marca de saúde feminina',
    href: 'https://startups.com.br/negocios/healthtechs/omens-expande-negocios-e-lanca-isha-marca-de-saude-feminina/',
    date: '2025-02-25'
  },
  {
    outlet: 'Veja Saúde',
    title: 'A febre dos hormônios: cresce uso indevido de testosterona e companhia',
    href: 'https://saude.abril.com.br/medicina/a-febre-dos-hormonios-cresce-uso-indevido-de-testosterona-e-companhia/',
    date: '2025-01-17'
  },
  {
    outlet: 'Folha de S.Paulo',
    title: 'Homens dependem de incentivo feminino para buscar cuidados médicos',
    href: 'https://www1.folha.uol.com.br/equilibrioesaude/2024/09/homens-dependem-de-incentivo-feminino-para-buscar-cuidados-medicos.shtml',
    date: '2024-09-10'
  },
  {
    outlet: 'UOL',
    title: 'Como aumentar o pênis: o que funciona e o que não funciona?',
    href: 'https://www.uol.com.br/vivabem/noticias/redacao/2023/08/18/como-aumentar-o-penis-o-que-funciona-e-o-que-nao-funciona.htm',
    date: '2023-08-18'
  },
  {
    outlet: 'Veja Saúde',
    title: 'Mercadores da cura',
    href: 'https://saude.abril.com.br/medicina/mercadores-da-cura/',
    date: '2023-07-24'
  },
  {
    outlet: 'Jornal de Brasília',
    title: 'Omens: plataforma especializada em saúde masculina desconstrói os tabus sobre autocuidados',
    href: 'https://jornaldebrasilia.com.br/blogs-e-colunas/analice-nicolau/omens-plataforma-especializada-em-saude-masculina-desconstroi-os-tabus-sobre-autocuidados-de-homens-e-lanca-servicos-de-dermatologia/',
    date: '2023-03-23'
  },
  {
    outlet: 'Estadão',
    title: 'Startups apostam no público masculino com produtos que vão de beleza a saúde sexual',
    href: 'https://www.estadao.com.br/link/inovacao/startups-apostam-no-publico-masculino-com-produtos-que-vao-de-beleza-a-saude-sexual/',
    date: '2022-12-07'
  },
  {
    outlet: 'O Tempo',
    title: 'Dia do Homem: eles valorizam o sexo, mas são negligentes quanto ao autocuidado',
    href: 'https://www.otempo.com.br/interessa/dia-do-homem-eles-valorizam-o-sexo-mas-sao-negligentes-quanto-ao-autocuidado-1.2699508',
    date: '2022-07-15'
  },
  {
    outlet: 'GQ Brasil',
    title: 'Novembro Azul: os homens ainda sentem preconceito com o exame de toque?',
    href: 'https://gq.globo.com/Corpo/Saude/noticia/2021/11/novembro-azul-os-homens-ainda-sentem-preconceito-com-o-exame-de-toque.html',
    date: '2021-11-29'
  },
  {
    outlet: 'Futuro da Saúde',
    title: 'Saúde do homem: startup investe em segmento pouco explorado',
    href: 'https://futurodasaude.com.br/saude-do-homem-startup-investe-em-segmento-pouco-explorado/',
    date: '2021-07-29'
  },
  {
    outlet: 'Veja Saúde',
    title: 'O novo normal do sexo',
    href: 'https://saude.abril.com.br/mente-saudavel/o-novo-normal-do-sexo/',
    date: '2021-07-28'
  },
  {
    outlet: 'Veja Saúde',
    title: 'Machismo faz, sim, mal à saúde',
    href: 'https://saude.abril.com.br/mente-saudavel/machismo-faz-sim-mal-a-saude/',
    date: '2021-06-30'
  },
  {
    outlet: 'G1',
    title: 'Por que homens com disfunção erétil não pedem ajuda',
    href: 'https://g1.globo.com/bemestar/blog/longevidade-modo-de-usar/post/2021/03/21/por-que-homens-com-disfuncao-eretil-nao-pedem-ajuda.ghtml',
    date: '2021-03-21'
  },
  {
    outlet: 'Terra',
    title: 'Pesquisa revela hábitos dos homens brasileiros na vida sexual e pessoal',
    href: 'https://www.terra.com.br/noticias/dino/pesquisa-revela-habitos-dos-homens-brasileiros-na-vida-sexual-e-pessoal,5856747d5d598ab1e5d9cc1c0c947cbaf0dzfxup.html',
    date: '2021-02-02'
  },
  {
    outlet: 'Minha Vida',
    title: '60% dos homens não falam sobre disfunções sexuais e ereção',
    href: 'https://www.minhavida.com.br/saude/materias/37267-60-dos-homens-nao-falam-sobre-disfuncoes-sexuais-e-erecao',
    date: '2021-01-28'
  },
  {
    outlet: 'Exame',
    title: 'Com aporte de R$ 1,4 mi, startup quer resolver a saúde sexual masculina',
    href: 'https://exame.com/pme/com-aporte-de-r-14-mi-startup-quer-resolver-a-saude-sexual-masculina/',
    date: '2020-12-30'
  }
]

const logo = (name: string, width: number, height: number, ext = 'svg'): PressLogo => ({
  src: { mint: `/landings/press/${name}-mint.${ext}`, dark: `/landings/press/${name}-dark.${ext}` },
  width,
  height
})

/** The logos of the press block (Morgan, 24/10/2026): one per article, the 5 outlets of the block, each linked to its article. */
export const PRESS_LOGOS: (PressItem & { logo: PressLogo })[] = [
  { outlet: 'O Tempo', logo: logo('o-tempo', 112, 16) },
  { outlet: 'Futuro da Saúde', logo: logo('futuro-da-saude', 82, 28, 'webp') },
  { outlet: 'Terra', logo: logo('terra', 80, 24) },
  { outlet: 'G1', logo: logo('g1', 27, 17) },
  { outlet: 'Exame', logo: logo('exame', 88, 15) }
].map(({ outlet, logo }) => ({ ...OMENS_PRESS.find((item) => item.outlet === outlet)!, logo }))

export const PRESS_PATH = '/imprensa'
